import type { SxProps, Theme } from '@mui/material';

export const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
};

export const answersSectionSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
};

export const commentSectionSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};

export const answerFieldHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  width: '100%',
  minWidth: 0,
};

export const answerStackSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '100%',
  minWidth: 0,
};

export const complianceToggleWrapSx: SxProps<Theme> = {
  width: { xs: '100%', sm: '50%' },
  minWidth: 0,
};
